<div class="strength">
    <ul class="strengthBar mt-2">
      <li class="point" [style.background-color]="bars[0]"></li>
      <li class="point" [style.background-color]="bars[1]"></li>
      <li class="point" [style.background-color]="bars[2]"></li>
      <li class="point" [style.background-color]="bars[3]"></li>
    </ul>
  
    @if (passwordToCheck?.length) {
        <div class="text-center mb-0" [style.color]="messageColor">{{ message }}</div>
    }
  </div>